export const isImage = (file) => {
  return file.type?.startsWith("image/");
};

export const sizedImg = (obj, field, size) => {
  if (!obj) return "";

  return obj[`${field.toString()}_sizes`]?.[size] || obj[field];
};

export const removeImageSizePrefix = (url) => {
  if (!url) return "";

  return url.replace(/\/(small|medium|large)_/i, "/");
};
